import { useEffect, useState, type CSSProperties } from 'react'
import { Link } from 'react-router-dom'
import { publicAsset } from '@/components/navigation/navigationAssets'
import { RESULTS_AVAILABLE_TIMESTAMP } from '@/app/electionSchedule'

const dayInMs = 24 * 60 * 60 * 1000

function getDaysUntilElection() {
  const diff = RESULTS_AVAILABLE_TIMESTAMP - Date.now()

  return Math.max(0, Math.ceil(diff / dayInMs))
}

export function HomeHero({ variant = 'home' }: { variant?: 'home' | 'candidates' }) {
  const [daysUntilElection, setDaysUntilElection] = useState(getDaysUntilElection)
  const textureStyle = {
    '--home-paper-texture': `url("${publicAsset('textures/textura-papel.webp')}")`,
  } as CSSProperties
  const dayLabel = daysUntilElection === 1 ? 'día' : 'días'

  useEffect(() => {
    const interval = window.setInterval(() => {
      setDaysUntilElection(getDaysUntilElection())
    }, 60 * 1000)

    return () => window.clearInterval(interval)
  }, [])

  return (
    <section
      className={`home-hero home-hero--${variant}`}
      aria-label={variant === 'candidates' ? 'Candidatos para las Elecciones Seccionales 2027' : 'Ecuador Elige, Elecciones Seccionales 2027'}
      style={textureStyle}
    >
      <div className="home-hero__copy">
        <p className="home-hero__eyebrow">Elecciones seccionales 2027</p>
        <h1>{variant === 'candidates' ? 'Candidatos' : '¿Qué harías si fueras alcalde o prefecto?'}</h1>
        <p>
          {variant === 'candidates'
            ? 'Conoce quiénes son, qué proponen y compara con información.'
            : 'Cuéntanos qué cambiarías primero en tu ciudad y participa en la conversación electoral de El Telégrafo.'}
        </p>
        {variant === 'home' ? <Link to="/reporteria-ciudadana">Conoce cómo participar -&gt;</Link> : null}
      </div>

      <picture className="home-hero__media">
        <source
          srcSet={publicAsset('images/portada-movil.webp')}
          media="(max-width: 700px)"
        />
        <img
          src={publicAsset('images/portada-desktop.webp')}
          alt=""
          decoding="async"
        />
      </picture>

      <div
        className="home-countdown"
        aria-label={`Faltan ${daysUntilElection} ${dayLabel} para el 29 de noviembre de 2026`}
      >
        <strong>Faltan</strong>
        <span>{daysUntilElection} {dayLabel}</span>
      </div>
    </section>
  )
}
